﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IMediaFilter } from "@app/filters/media.filter";
import { IThumbFilter } from "@app/filters/thumb.filter";
import { Dirs } from "@app/helpers/dirs";
import { KbService } from "@app/services/kb.service";
import { StorageService } from "@app/services/storage.service";
import { IRootScope } from "@models";
import { extensions, Utils } from "@tools";

export interface IMediaViewerScope extends ng.IScope {
    /**
     * The path to the file
     */
    path: string;
    /**
     * Whether to show the media as a thumbnail or not
     */
    thumb: boolean; //
    /**
     * Whether to show the controls in the video player
     */
    controls: boolean;
    cachebuster: boolean;
}
   
@NgComponent({
    token: Token.KbMediaViewer,
    dependencies: [
        Token.$Filter,
        Token.KbService,
        Token.$Sce,
        Token.$RootScope,
        Token.StorageService
    ]
})
export class KbMediaViewer extends Directive {
    constructor(
        $filter: ng.IFilterService,
        kbService: KbService,
        $sce: ng.ISCEService,
        $rootScope: IRootScope,
        storageService: StorageService
    ) {
        super();

        this.replace = true;
        this.restrict = "EA";
        this.template = Dirs.component("kb-media-viewer");
        this.scope = {
            path: "=",
            thumb: "@",
            cachebuster: "=?"
        };

        this.link = (scope: any, element, atts: any) => {
                
            //// for some reason the classes aren't getting merged
            //// but it is shown correctly in atts.  Here's a workaround
            // element.removeClass();
            // element.addClass(atts.class);
            scope.fallback = storageService.getFallbackImage();

            scope.$watch("path", newValue => {
                scope.ext = kbService.getExtension(scope.path);
                if (scope.ext == "ogv") scope.ext = "ogg";

                if (extensions.image.indexOf(scope.ext) != -1) {
                    scope.type = "image";
                    if (scope.thumb) {
                        scope.fullPath = (($filter as any)("thumb") as IThumbFilter)(scope.path);
                    } else {
                        scope.fullPath = (($filter as any)("media") as IMediaFilter)(scope.path);
                    }
                } else if (extensions.video.indexOf(scope.ext) != -1) {
                    scope.type = "video";
                    scope.fullPath = (($filter as any)("media") as IMediaFilter)(scope.path);
                }

                if (Utils.isAbsoluteUrl(scope.path)) {
                    scope.fullPath = scope.path;
                }
                if (scope.cachebuster) {
                    scope.fullPath = scope.fullPath + "?v=" + $rootScope.cacheBuster;
                }
                scope.fullPath = $sce.trustAsResourceUrl(scope.fullPath);
            });
        };
    }
}
